import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ReportFavoritesStore {
  favorites: string[];
  toggleFavorite: (reportId: string) => void;
  isFavorite: (reportId: string) => boolean;
}

export const useReportFavoritesStore = create<ReportFavoritesStore>()(
  persist(
    (set, get) => ({
      favorites: [],
      toggleFavorite: (reportId) => {
        const { favorites } = get();
        if (favorites.includes(reportId)) {
          set({ favorites: favorites.filter((id) => id !== reportId) });
        } else {
          set({ favorites: [...favorites, reportId] });
        }
      },
      isFavorite: (reportId) => {
        return get().favorites.includes(reportId);
      },
    }),
    {
      name: 'report-favorites-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
